import { emailRegExp } from '@elfsight/lib-utils';

export function checkEmailNode(value: string | null) {
  if (!value) {
    return false;
  }

  return emailRegExp.test(value.trim());
}
